module.exports = __webpack_public_path__ + "img/top-left-blop.f6508865.svg";